import React, { type FC } from 'react'
import { Divider, Grid, Typography } from '@mui/material'

import { isArrayNotEmpty } from '../../../../utils'

import { selectExplorerTail, Translation } from '../../../../domain'

import { Delay } from '../../common'
import { FormattedTranslation } from '../../Internationalization'
import { useAppState } from '../../State'
import { Section } from '../Section'
import { Controls } from './Controls'
import { Header } from './Header'
import { TailLine } from './Line'
import { TailSize } from './TailSize'

const Content: FC = () => {
    const tail = useAppState(selectExplorerTail)

    return (
        <Delay delay={300}>
            {isArrayNotEmpty(tail) ? (
                tail.map((line, k) => <TailLine key={k} {...line} />)
            ) : (
                <Typography variant="body2" align="center">
                    <FormattedTranslation id={Translation.NO_MESSAGES} />
                </Typography>
            )}
        </Delay>
    )
}

export const History: FC = () => (
    <Section
        data-testid="topicsHistory"
        title={Translation.HISTORY}
        controls={
            <>
                <Controls />
                <TailSize />
            </>
        }
    >
        <Divider />
        <Header />

        <Grid data-testid="topicsTail" size={{ xs: 12 }}>
            <Content />
        </Grid>
    </Section>
)
